import React from 'react';

import {PageFooter} from '@pb/kit-component-page-v2';

const copyrightSymbol = String.fromCharCode(0xA9);
const currentYear = new Date().getFullYear();

type DefaultAppFooterProps = {
    whiteTheme?: boolean,
};

export const DefaultAppFooter = ({whiteTheme}: DefaultAppFooterProps) => (
    <PageFooter
        copyright={`${copyrightSymbol} ${currentYear} PitchBook Data, Inc. All rights reserved.`}
        style={whiteTheme ? {color: '#fff'} : undefined}>
        <a
            href="https://pitchbook.com/terms-of-use"
            target="_blank"
            style={whiteTheme ? {color: '#fff'} : undefined}>Terms of Use
        </a>
        <a
            href="https://pitchbook.com/privacy-policy"
            target="_blank"
            style={whiteTheme ? {color: '#fff'} : undefined}>Privacy
        </a>
    </PageFooter>
);
